module.exports = __webpack_public_path__ + "static/media/b4.1fe76bae.jpg";